import React from "react";
import { useTranslation } from "react-i18next";
import { PBtn, PNumber } from "./ui";

type Column = "ribbed" | "smooth" | "weldableExtra";

type DiameterRow = {
  diameter: number;
  ribbed: number | null;
  smooth: number | null;
  weldableExtra: number | null;
};

export default function MobileDiameterPrices({
  rows,
  onChange,
  onFillMissing,
}: {
  rows: DiameterRow[];
  onChange: (diameter: number, column: Column, value: string) => void;
  onFillMissing: (column: Column) => void;
}) {
  const { t } = useTranslation(["supplierPricing", "common"]);
  const columns: Column[] = ["ribbed", "smooth"];

  if (!rows.length) {
    return <p className="eb-pr-muted eb-pr-mobile-empty">{t("diameter.subtitle")}</p>;
  }

  return (
    <div className="eb-pr-diameter-mobile">
      <div className="eb-pr-mobile-fill">
        {columns.map((column) => (
          <PBtn key={column} kind="ghost" size="sm" onClick={() => onFillMissing(column)}>
            {t(`diameter.${column}`)} · {t("diameter.fillMissing")}
          </PBtn>
        ))}
      </div>
      <div className="eb-pr-mobile-price-list">
        {rows.map((row) => (
          <article key={row.diameter} className="eb-pr-mobile-price-card">
            <header>
              <strong>Ø {row.diameter} mm</strong>
            </header>
            <div className="eb-pr-mobile-price-fields">
              {columns.map((column) => (
                <label key={column}>
                  <span>{t(`diameter.${column}`)}</span>
                  <PNumber
                    ariaLabel={`${row.diameter} ${column}`}
                    value={row[column]}
                    warn={row[column] === null}
                    placeholder={column === "ribbed" ? t("diameter.missing") : "—"}
                    onChange={(value) => onChange(row.diameter, column, value)}
                  />
                </label>
              ))}
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}